<!-- CustomInput.vue -->
<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'

export default {
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  props: {
    id: String,
    labelName: String,
    required: '',
    modelValue: String,
    step: '',
    inputType: String
  },
  data() {
    return {
      store,
      typeInput: ''

    }
  },
  emits: ['update:modelValue'],
  methods: {},
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    isRequired() {
      if (this.required) {
        if (this.required.length > 0) return true;
      } else return false;
    },
    isBlurred() {
      if (this.step) {
        if (this.store.form.steps[this.step].blurred) return true; else return false;
      }
    },
  },

}
</script>

<template>
  <div class="form-label-group">
    <input type="text" v-if="!isRequired" :id="id" class="form-control" v-model.number="value"
           :placeholder="t(labelName)"/>
    <input type="text" v-if="isRequired" :id="id" class="form-control" v-model.number="value"
           :placeholder="t(labelName)"
           :class="{'is-invalid': isRequired && !value && isBlurred}" required=""/>
    <label :for="id">
      <!--    Nazev v prekladu-->
      {{ t(labelName) }}</label>
    <div v-if="isRequired" class="invalid-feedback">
      {{ t(required) }}
    </div>
  </div>
</template>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>